export const OPTION_NUMBERS = Array.from({ length: 10 }, (_, index) =>
  String(index + 1),
);

export function getOptionSelectValue(conditionalPath: string): string {
  if (!conditionalPath.trim()) return "1";
  const stripped = conditionalPath.trim().replace(/^option\s*/i, "");
  return stripped || "1";
}
